module.exports = __webpack_public_path__ + "img/icon-exit.9dfb0ca4.svg";